import { Navigate } from "react-router-dom";
import ClientDealView from "@/pages/deals/ClientDealView";
import { PUBLIC_ROUTES } from "@/routes/url";
import type { DealParticipation } from "@/types/authentication.types";

interface ClientOverviewProps {
  participation?: DealParticipation | null;
}

export default function ClientOverview({ participation }: ClientOverviewProps) {
  if (!participation?.deal_id) return <Navigate to={PUBLIC_ROUTES.LANDING} replace />;
  return <ClientDealView dealId={participation.deal_id} embedded />;
}
